export default __webpack_public_path__ + "static/media/logo.0edc9b29.png";